import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

let searchParameter = {};

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  let searchParameter = { ...sectionComponent.state.searchParameter };
  searchParameter[uie.source] = parameter;
  sectionComponent.setState({ searchParameter, componentDefaultValue });

  let filterLoaded = true;
  sectionComponent.state.section.componentList.filter(c => c.type === 'View')[0].topFilterList[0].uieList.map((uie, i) => {
    if (componentDefaultValue[uie.source] === undefined) {
      filterLoaded = false;
    }
  })

  if (filterLoaded) {
    setTimeout(() => {
      sectionComponent.getSectionDataByDefault();
    }, config.setTimeoutMilliSecond);
  }
}

export function editFee({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .get('Admin/CouncilApplicationType/GetWithFeeList?lgaId=' + parameter.LgaId)
    .then(({ data }) => {
      if (data.result) {
        pageComponent.setState({ lgaData: parameter, showModal: true });
        pageComponent.councilApplicationFeeFormRef.current?.setFieldsValue({ CouncilApplicationFeeList: data.data });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function editPrivateNote({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .get('Admin/LgaPrivateNote/GetDetailByLga?lgaId=' + parameter.LgaId)
    .then(({ data }) => {
      if (data.result) {
        // 每次打开弹窗均重置到 Building 标签页。
        pageComponent.setState({
          lgaData: parameter,
          showPrivateNote: true,
          activePrivateNoteTab: 'Building',
        });
        if (Number(pageComponent.props.authUser.CompanyId) === 3) {
          pageComponent.privateNoteFormRef.current?.setFieldsValue({
            Note: data.data?.Note || '',
            PlanningNote: data.data?.PlanningNote || '',
          });
        } else {
          pageComponent.privateNoteFormRef.current?.setFieldsValue({ Note: data.data?.Note || '' });
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}
